import { render, staticRenderFns } from "./AdministrateVideosModal.vue?vue&type=template&id=724b658e&"
import script from "./AdministrateVideosModal.vue?vue&type=script&lang=ts&"
export * from "./AdministrateVideosModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports